export const importModelV2 = `mutation ($model: ImportPMRequest!){
    importPM(input: $model) {
            kmatID,
            modVer
        }
    }`;
    